const SignIn = () => {
  return (
    <div>
      <h2>Please Sign in Here</h2>
    </div>
  );
};
export default SignIn;
